























































import { Vue, Component } from "vue-property-decorator";
import { UserInterface } from "@/resources/interfaces/userInterfaces";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import VueTagsInput from "@johmun/vue-tags-input";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
@Component({
  name: "profile-cv-component",
  components: {
    VueTagsInput,
  },
})
export default class CvComponent extends mixins(Vue, NotificationEvent) {
  TYPE_KNOWLEDGE = {
    EXPERIENCE: "EXPERIENCE",
    LEARNIG: "LEARNIG",
    PROJECT_PARTICIPATION: "PROJECT_PARTICIPATION",
  };
  loading = false;
  experienceTagModel = "";
  experienceTag = [];
  filterExperienceTag = [];
  learningTagModel = "";
  learningTag = [];
  filterLearnigTag = [];
  projectParticipationTagModel = "";
  projectParticipationTag = [];
  filterProjectParticipationTag = [];
  user: UserInterface;
  mounted() {
    this.user = this.$store.getters["UserStore/getUser"];
    this.loadTag();
    this.getFilterTags();
  }
  getFilterTags() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (!space) return;
    this.$store.dispatch("SuperSpaceStore/getSuperSpaceTagAction", {
      superSpaceId: space.superSpace.id,
      callback: (response) => {
        this.filterExperienceTag = this.createJsonTag(response.EXPERIENCE);
        this.filterLearnigTag = this.createJsonTag(response.LEARNING);
        this.filterProjectParticipationTag = this.createJsonTag(
          response.PROJECTS
        );
      },
      callbackError: (error) => {},
    });
  }
  filterItem(type: string) {
    switch (type) {
      case this.TYPE_KNOWLEDGE.EXPERIENCE:
        return this.filterExperienceTag.filter((i) => {
          return (
            i.text
              .toLowerCase()
              .indexOf(this.experienceTagModel.toLowerCase()) !== -1
          );
        });
      case this.TYPE_KNOWLEDGE.LEARNIG:
        return this.filterLearnigTag.filter((i) => {
          return (
            i.text
              .toLowerCase()
              .indexOf(this.learningTagModel.toLowerCase()) !== -1
          );
        });
      case this.TYPE_KNOWLEDGE.PROJECT_PARTICIPATION:
        return this.filterProjectParticipationTag.filter((i) => {
          return (
            i.text
              .toLowerCase()
              .indexOf(this.projectParticipationTagModel.toLowerCase()) !== -1
          );
        });
    }
  }
  updateUserData(): void {
    this.loading = true;
    this.$store.dispatch("UserStore/updateUserAction", {
      userId: this.user.id,
      props: {
        experienceTag: this.createJsonTagApi(this.experienceTag),
        learningTag: this.createJsonTagApi(this.learningTag),
        projectParticipationTag: this.createJsonTagApi(
          this.projectParticipationTag
        ),
      },
      callback: (user) => {
        this.loading = false;
        this.$store.dispatch("SpaceStore/updateUserInSpace", user);
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.userUpdate")
        );
        this.user = this.$store.getters["UserStore/getUser"];
        this.loadTag();
      },
      callbackError: (error) => {
        this.loading = false;
        this.onError("", i18n.t("notifications.errorMessages.updatePerfil"));
      },
    });
  }
  addNewTag(newTags: any, type: string) {
    switch (type) {
      case this.TYPE_KNOWLEDGE.EXPERIENCE:
        this.experienceTag = newTags;
        break;
      case this.TYPE_KNOWLEDGE.LEARNIG:
        this.learningTag = newTags;
        break;
      case this.TYPE_KNOWLEDGE.PROJECT_PARTICIPATION:
        this.projectParticipationTag = newTags;
        break;
    }
  }
  createJsonTag(array: any[]): any[] {
    let newArray = [];
    array.forEach((tag) => {
      newArray.push({ text: tag });
    });
    return newArray;
  }
  createJsonTagApi(array: any[]): any[] {
    let newArray = [];
    array.forEach((tag) => {
      newArray.push(tag.text);
    });
    return newArray;
  }
  loadTag() {
    this.experienceTag = this.user.experienceTag
      ? this.createJsonTag(this.user.experienceTag)
      : [];
    this.learningTag = this.user.learningTag
      ? this.createJsonTag(this.user.learningTag)
      : [];
    this.projectParticipationTag = this.user.projectParticipationTag
      ? this.createJsonTag(this.user.projectParticipationTag)
      : [];
  }
}
